'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatCustomObjectType = objectType => {
  return new ReferenceRecord({
    id: String(objectType.objectTypeId),
    // NOTE: the backend does not provide singularForm/pluralForm for built-in HubSpot-defined
    //       object types, because any hard-coded string sent back would not be properly translated.
    //       It's up to the caller to translate the names of HubSpot-defined object types.
    label: objectType.singularForm || '',
    referencedObject: fromJS(objectType)
  });
};
const formatCustomObjectTypes = objectTypes => {
  return indexBy(get('id'), List(objectTypes).map(formatCustomObjectType));
};
export default formatCustomObjectTypes;